/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    V1LocalObjectReference,
    V1LocalObjectReferenceFromJSON,
    V1LocalObjectReferenceFromJSONTyped,
    V1LocalObjectReferenceToJSON,
} from './V1LocalObjectReference';

/**
 * ISCSI volumes can only be mounted as read/write once.
 * ISCSI volumes support ownership management and SELinux relabeling.
 * @export
 * @interface V1ISCSIVolumeSource
 */
export interface V1ISCSIVolumeSource {
    /**
     * chapAuthDiscovery defines whether support iSCSI Discovery CHAP authentication
     * +optional
     * @type {boolean}
     * @memberof V1ISCSIVolumeSource
     */
    chapAuthDiscovery?: boolean;
    /**
     * chapAuthSession defines whether support iSCSI Session CHAP authentication
     * +optional
     * @type {boolean}
     * @memberof V1ISCSIVolumeSource
     */
    chapAuthSession?: boolean;
    /**
     * fsType is the filesystem type of the volume that you want to mount.
     * Tip: Ensure that the filesystem type is supported by the host operating system.
     * Examples: "ext4", "xfs", "ntfs". Implicitly inferred to be "ext4" if unspecified.
     * More info: https://kubernetes.io/docs/concepts/storage/volumes#iscsi
     * TODO: how do we prevent errors in the filesystem from compromising the machine
     * +optional
     * @type {string}
     * @memberof V1ISCSIVolumeSource
     */
    fsType?: string;
    /**
     * initiatorName is the custom iSCSI Initiator Name.
     * If initiatorName is specified with iscsiInterface simultaneously, new iSCSI interface
     * <target portal>:<volume name> will be created for the connection.
     * +optional
     * @type {string}
     * @memberof V1ISCSIVolumeSource
     */
    initiatorName?: string;
    /**
     * iqn is the target iSCSI Qualified Name.
     * @type {string}
     * @memberof V1ISCSIVolumeSource
     */
    iqn?: string;
    /**
     * iscsiInterface is the interface Name that uses an iSCSI transport.
     * Defaults to 'default' (tcp).
     * +optional
     * +default="default"
     * @type {string}
     * @memberof V1ISCSIVolumeSource
     */
    iscsiInterface?: string;
    /**
     * lun represents iSCSI Target Lun number.
     * @type {number}
     * @memberof V1ISCSIVolumeSource
     */
    lun?: number;
    /**
     * portals is the iSCSI Target Portal List. The portal is either an IP or ip_addr:port if the port
     * is other than default (typically TCP ports 860 and 3260).
     * +optional
     * +listType=atomic
     * @type {Array<string>}
     * @memberof V1ISCSIVolumeSource
     */
    portals?: Array<string>;
    /**
     * readOnly here will force the ReadOnly setting in VolumeMounts.
     * Defaults to false.
     * +optional
     * @type {boolean}
     * @memberof V1ISCSIVolumeSource
     */
    readOnly?: boolean;
    /**
     * 
     * @type {V1LocalObjectReference}
     * @memberof V1ISCSIVolumeSource
     */
    secretRef?: V1LocalObjectReference;
    /**
     * targetPortal is iSCSI Target Portal. The Portal is either an IP or ip_addr:port if the port
     * is other than default (typically TCP ports 860 and 3260).
     * @type {string}
     * @memberof V1ISCSIVolumeSource
     */
    targetPortal?: string;
}

export function V1ISCSIVolumeSourceFromJSON(json: any): V1ISCSIVolumeSource {
    return V1ISCSIVolumeSourceFromJSONTyped(json, false);
}

export function V1ISCSIVolumeSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1ISCSIVolumeSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'chapAuthDiscovery': !exists(json, 'chapAuthDiscovery') ? undefined : json['chapAuthDiscovery'],
        'chapAuthSession': !exists(json, 'chapAuthSession') ? undefined : json['chapAuthSession'],
        'fsType': !exists(json, 'fsType') ? undefined : json['fsType'],
        'initiatorName': !exists(json, 'initiatorName') ? undefined : json['initiatorName'],
        'iqn': !exists(json, 'iqn') ? undefined : json['iqn'],
        'iscsiInterface': !exists(json, 'iscsiInterface') ? undefined : json['iscsiInterface'],
        'lun': !exists(json, 'lun') ? undefined : json['lun'],
        'portals': !exists(json, 'portals') ? undefined : json['portals'],
        'readOnly': !exists(json, 'readOnly') ? undefined : json['readOnly'],
        'secretRef': !exists(json, 'secretRef') ? undefined : V1LocalObjectReferenceFromJSON(json['secretRef']),
        'targetPortal': !exists(json, 'targetPortal') ? undefined : json['targetPortal'],
    };
}

export function V1ISCSIVolumeSourceToJSON(value?: V1ISCSIVolumeSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'chapAuthDiscovery': value.chapAuthDiscovery,
        'chapAuthSession': value.chapAuthSession,
        'fsType': value.fsType,
        'initiatorName': value.initiatorName,
        'iqn': value.iqn,
        'iscsiInterface': value.iscsiInterface,
        'lun': value.lun,
        'portals': value.portals,
        'readOnly': value.readOnly,
        'secretRef': V1LocalObjectReferenceToJSON(value.secretRef),
        'targetPortal': value.targetPortal,
    };
}

